import { FC, useEffect, useMemo, useState } from "react";
// 组件
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { ProModal, ProForm, ProInput } from '../antd';
// 常量
import { AuditOrderProps, AuditOrderType } from "./interface";
import { IObject } from '../constants/interface';
import { SUCCESS_STATUS_CODE } from "../constants/constant";
import { Rule } from "antd/lib/form";
import './style.less';

/** 审核 */
const AuditOrder: FC<AuditOrderProps> = props => {
  const {
    title, required, type, orderSn, label, name, orderId, orderIdName, actionRef, otherParams,
    passApi, rejectApi, onSuccess, onError, ...restProps
  } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalType, setModalType] = useState<AuditOrderType>(); // 类型 通过、驳回
  const [form] = ProForm.useForm();
  useEffect(() => {
    setModalType(type);
  }, [type]);
  /** 显示 */
  const handleShow = (data: AuditOrderType) => {
    setVisible(true);
    setModalType(data);
    form.resetFields();
  };
  /** 隐藏 */
  const handleHide = () => {
    setVisible(false);
  };
  /** 点击确定确定 */
  const handleOk = () => {
    form.submit();
  };
  /** 提交 */
  const handleFinish = async (values: any) => {
    const params: IObject = {...values, ...otherParams, };
    if (orderIdName && orderId) params[orderIdName] = orderId;
    const fetchApi = modalType === 'pass' ? passApi : rejectApi;
    setLoading(true);
    const passRes = await fetchApi(params);
    setLoading(false);
    handleHide();
    if (passRes && passRes.code === SUCCESS_STATUS_CODE) {
      const data = passRes.data;
      onSuccess?.(data);
      return;
    }
    onError?.(passRes);
  };
  const okButtonProps = useMemo(() => {
    return {
      loading: loading,
    };
  }, [loading]);
  /** 标题 */
  const titleNode = useMemo(() => {
    if (title) return title;
    if (modalType === 'pass') return `确认审批通过 ${orderSn ?? ''}？`;
    if (modalType === 'reject') return `确认审批驳回 ${orderSn ?? ''}？`;
  }, [title, modalType, orderSn]);
  const textAreaRule: Rule[] | undefined = useMemo(() => {
    if (required) {
      return [
        {
          required: true,
          message: `请输入${label}`,
        },
      ];
    }
  }, [label, required]);
  if (actionRef) {
    actionRef.current = {
      show: handleShow,
      hide: handleHide,
    };
  }
  return (
    <ProModal
      open={visible}
      destroyOnClose
      okButtonProps={okButtonProps}
      closable={false}
      width={416}
      onOk={handleOk}
      onCancel={handleHide}
      {...restProps}
    >
      <div className="yb-audit-order">
        <div className="yb-audit-order-title">
          <ExclamationCircleOutlined className="yb-audit-order-title-icon" />
          {titleNode}
        </div>
        <div>
          <ProForm form={form} onFinish={handleFinish}>
            <ProForm.Item label={label} name={name} rules={textAreaRule}>
              <ProInput.TextArea rows={4} showCount={true} placeholder="请填写审批意见，最多200个字" />
            </ProForm.Item>
          </ProForm>
        </div>
      </div>
    </ProModal>
  );
};

AuditOrder.defaultProps = {
  label: '审批意见',
  name: 'auditorComment',
  type: 'pass',
};

export default AuditOrder;
